'use client';

import React from 'react';
import { cn } from '@/app/_lib/utils';
import { SyncCircleOutline } from 'react-ionicons';

type Button = {
  label: string;
  autofocus?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  type?: 'reset' | 'button' | 'submit' | undefined;
  onClick?: any;
  className?: string;
  isLoading?: boolean;
  dataTestId?: string;
  variant: 'primary' | 'secondary' | 'tertiary' | 'dark' | 'light';
};

const Button = ({
  label,
  autofocus,
  disabled,
  hidden,
  type = 'button',
  onClick,
  className,
  isLoading = false,
  variant,
  dataTestId,
  ...restOfProps
}: Button) => {
  return (
    <button
      autoFocus={autofocus}
      disabled={disabled}
      hidden={hidden}
      onClick={onClick}
      type={type}
      data-test-id={dataTestId}
      className={cn(`btn-${variant}`, className)}
      {...restOfProps}
    >
      <span className="flex flex-row justify-center gap-1">
        {isLoading && (
          <span>
            <SyncCircleOutline
              color={'#00000'}
              rotate
              height="20px"
              width="20px"
            />
          </span>
        )}
        <span>{label}</span>
      </span>
    </button>
  );
};

export default Button;
